import type { SelfSupplyEligibleMarket } from "./selfSupplyEligibility";
import {
  getSimplifiedPresentationCreatedDateCutoff,
  getSimplifiedPresentationTargets,
} from "./simplifiedPresentationEligibility";
import { FeatureFlags } from "fixtures/features";

type OfferReviewSimplifiedFlagsmith = {
  getValue: (
    feature: string,
    options?: { json?: boolean; fallback?: unknown }
  ) => unknown;
};

type OfferReviewSimplifiedFlagSlice = Record<
  string,
  { enabled?: boolean } | undefined
>;

type OfferReviewSimplifiedFlagInputs = {
  offerReviewSimplifiedEnabled: boolean;
  presentationTargets: SelfSupplyEligibleMarket[];
  createdDateCutoff: string | undefined;
};

const getOfferReviewSimplifiedFlagInputs = (
  flagsmith: OfferReviewSimplifiedFlagsmith,
  flags: OfferReviewSimplifiedFlagSlice
): OfferReviewSimplifiedFlagInputs => {
  const offerReviewSimplifiedEnabled =
    flags[FeatureFlags.OFFER_REVIEW_SIMPLIFIED]?.enabled ?? false;

  const flagValue = flagsmith.getValue(FeatureFlags.OFFER_REVIEW_SIMPLIFIED, {
    json: true,
    fallback: {},
  });

  return {
    offerReviewSimplifiedEnabled,
    presentationTargets: getSimplifiedPresentationTargets(flagValue),
    createdDateCutoff: getSimplifiedPresentationCreatedDateCutoff(flagValue),
  };
};

export { getOfferReviewSimplifiedFlagInputs };
export type {
  OfferReviewSimplifiedFlagInputs,
  OfferReviewSimplifiedFlagsmith,
  OfferReviewSimplifiedFlagSlice,
};
